export const WEBSKY_SERVICE_OPEN_EVENT = 'webskyServiceOpen';
export const WEBSKY_BAGGAGE_SERVICE_OPEN_EVENT = 'webskyBaggageServiceOpen';
